import { HttpClient } from '../http-client/apiClient';
import { API_ENDPOINTS, AUTH_CRED } from '../http-client/httpConstants';
import {
  RegisterDto,
  LoginDto,
  RefreshTokenDto,
  AuthResponse,
  LogoutResponse,
  MeDto,
} from '../jwt-token-access/authTypes';

export class AuthClient {
  static async register(data: RegisterDto): Promise<AuthResponse> {
    const response = await HttpClient.post<AuthResponse>(API_ENDPOINTS.AUTH.REGISTER, data);
    localStorage.setItem(
      AUTH_CRED,
      JSON.stringify({ token: response.accessToken, refreshToken: response.refreshToken }),
    );
    return response;
  }

  static async login(data: LoginDto): Promise<AuthResponse> {
    const response = await HttpClient.post<AuthResponse>(API_ENDPOINTS.AUTH.LOGIN, data);
    localStorage.setItem(
      AUTH_CRED,
      JSON.stringify({ token: response.accessToken, refreshToken: response.refreshToken }),
    );
    return response;
  }

  static async refresh(data: RefreshTokenDto): Promise<AuthResponse> {
    const response = await HttpClient.post<AuthResponse>(API_ENDPOINTS.AUTH.REFRESH, data);
    localStorage.setItem(
      AUTH_CRED,
      JSON.stringify({ token: response.accessToken, refreshToken: response.refreshToken }),
    );
    return response;
  }

  static async logout(): Promise<LogoutResponse> {
    const response = await HttpClient.post<LogoutResponse>(API_ENDPOINTS.AUTH.LOGOUT);
    localStorage.removeItem(AUTH_CRED);
    return response;
  }

  static async logoutSession(sessionId: string): Promise<LogoutResponse> {
    const response = await HttpClient.post<LogoutResponse>(
      `${API_ENDPOINTS.AUTH.LOGOUT_SESSION}/${sessionId}`,
    );
    return response;
  }

  static async getCurrentUser(): Promise<MeDto> {
    return HttpClient.get<MeDto>(API_ENDPOINTS.AUTH.ME);
  }
}
